<div class="p-5">
  <div class="flex justify-between items-center mb-2">
    <div class="text-lg text-gray-700 font-bold">Histórico de alterações</div>
    <button class="btn-icon" (click)="close()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="text-sm text-gray-500 mb-4">
    TG {{ data.item.codigoTg }} · OS {{ data.item.codigoOs }}
  </div>

  @if (data.item.alteracoes.length === 0) {
    <div class="text-gray-400 text-sm">Nenhuma alteração registrada.</div>
  } @else {
    <div class="timeline">
      @for (alteracao of data.item.alteracoes; track $index) {
        <div class="timeline-item">
          <div class="text-sm">
            <b>{{ labelCampo(alteracao) }}</b>: {{ alteracao.de || '—' }} → <b>{{ alteracao.para }}</b>
          </div>
          <div class="text-xs text-gray-500">{{ formatarQuando(alteracao.em) }} · {{ alteracao.por }}</div>
        </div>
      }
    </div>
  }

  <div class="flex justify-end mt-4">
    <button mat-flat-button class="btn-tg-white" (click)="close()">Fechar</button>
  </div>
</div>
